<script lang="ts" setup>
const props = defineProps<{
  url: string;
}>();

const emit = defineEmits(["on-click", "on-close"]);
const loading = ref(true);

const onIframeError = () => {
  console.error("Error occurred while loading iframe content!");
  loading.value = false;
};

const onIframeLoad = () => {
  loading.value = false;
};

const { isLoading, execute: onAsyncClick } = useAsyncState(
  (fn: (() => void) | (() => Promise<void>)) => Promise.resolve().then(fn),
  undefined,
  { immediate: false },
);

function onActionClick(action: "confirm" | "cancel"): Promise<void> {
  if (action === "confirm")
    return onAsyncClick(0, () => emit("on-click"));
  else if (action === "cancel")
    return onAsyncClick(0, () => emit("on-close"));
  return onAsyncClick(0, Promise.resolve);
}

const messageHandler = (event: MessageEvent) => {
  if (event.origin.includes("monday.com")) {
    if (event.data.type === "submit_success") {
      emit("on-click");
    }
  }

  if (event.origin.includes("https://form.typeform.com")) {
    if (event.data.type === "form-submit") {
      emit("on-click");
    }
  }
};

onMounted(() => {
  window.addEventListener("message", messageHandler, false);
});

onBeforeUnmount(() => {
  window.removeEventListener("message", messageHandler, false);
});
</script>

<template>
  <div class="relative">
    <div v-if="loading" class="skeletonLoading w-full absolute top-0 bottom-0 left-0 right-0 h-[750px] z-10" />

    <div class="flex flex-col h-[750px] rounded-md overflow-hidden w-[600px] relative items-center justify-center bg-white">
      <div class="absolute top-4 right-4">
        <BaseButton
          name="close"
          type="icon"
          class="h-5 w-5"
          :disabled="isLoading"
          @click="onActionClick('cancel')"
        >
          <IconClose class="relative z-10" />
        </BaseButton>
      </div>
      <iframe
        :src="props.url"
        height="100%"
        width="100%"
        title="User Survey"
        frameborder="0"
        style="background: white;"
        scrolling="no"
        @load="onIframeLoad"
        @error="onIframeError"
      />
    </div>
  </div>
</template>
